import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { isMailboxSharedOrDelegateUserMailbox } from 'owa-account-shared-mailbox-utils';
import { isBizchatSidepaneEnabled } from 'owa-bizchat-shared/lib/utils/isBizchatSidepaneEnabled';
import { isCohortAISKU } from 'owa-bizchat-shared/lib/utils/isCohortAISKU';
import { UserCohort } from 'owa-bizchat-shared/lib/store/store';
import { getUserCohort } from 'owa-bizchat-shared/lib/utils/getUserCohort';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

/**
 * Checks if the core Search Plus Chat prerequisites are met for the given mailbox.
 * This includes AI licensing, mailbox type validation, and base feature flags.
 */
export function isSearchPlusChatFeatureEnabled(mailboxInfo?: MailboxInfo): boolean {
    const targetMailboxInfo = mailboxInfo || getModuleContextMailboxInfo();

    // Check if the feature is enabled for starter SKU
    const isEnabledForStarterSKU = isFeatureEnabled('sea-searchPlusChat-enableForStarterSKU');

    // Check if user is in Starter SKU cohort (BCWAF)
    const userCohort = getUserCohort(targetMailboxInfo);
    const isStarterUser =
        !isConsumer(undefined, targetMailboxInfo) && userCohort === UserCohort.BCWAF;

    // Check if BizChat and AI features are enabled
    const isChatAndAIEnabled =
        isFeatureEnabled('mon-copilot-bizchat') &&
        !!isBizchatSidepaneEnabled(targetMailboxInfo) &&
        ((isEnabledForStarterSKU && isStarterUser) || !!isCohortAISKU(targetMailboxInfo));

    // Don't support shared or delegate mailboxes
    const isSharedOrDelegateMailbox = isMailboxSharedOrDelegateUserMailbox(targetMailboxInfo);

    // Don't support archive mailboxes
    const isArchiveMailbox = targetMailboxInfo.type === 'ArchiveMailbox';

    // Check required search feature flags
    const hasSearchFeatureFlags = isFeatureEnabled('sea-searchPlusChat-noSERPUpdate');

    return (
        isChatAndAIEnabled &&
        !isSharedOrDelegateMailbox &&
        !isArchiveMailbox &&
        hasSearchFeatureFlags
    );
}
